import { AlertProps, Alert as MuiAlert } from "@mui/material";
import { SpacingProps } from "@mui/system";

export type Props = AlertProps & SpacingProps;

export const Alert: React.FC<Props> = (props) => <MuiAlert {...props} />;
